'use client';

import { ArrowRightIcon } from 'lucide-react';

import { Link } from '@/components/Link/Link';
import { href } from '@/lib/links-fields';
import { useBookDemoTrackingHandler } from '@/lib/tracking/useBookDemoTrackingHandler';
import type { LinkField } from '@/types';

import { ButtonLink } from '../Button/ButtonLink';

import styles from './Content.module.scss';

type Props = {
    link: LinkField;
};

export function TrackedLink({ link }: Props) {
    const handleClick = useBookDemoTrackingHandler(link);

    const isRegularLink = link.mode === 'default';
    const shouldOpenInNewTab = link.newTab ?? false;

    return isRegularLink ? (
        <Link
            href={href(link)}
            className={styles.link}
            onClick={handleClick}
            shouldOpenInNewTab={shouldOpenInNewTab}
        >
            {link.label}
            <ArrowRightIcon className={styles.icon} />
        </Link>
    ) : (
        <ButtonLink
            href={href(link)}
            size="large"
            className={styles.button}
            onClick={handleClick}
            // @ts-expect-error
            variant={link.mode}
            shouldOpenInNewTab={shouldOpenInNewTab}
        >
            {link.label}
        </ButtonLink>
    );
}
